import { Address } from "@/types/address.types";

export type ExportFormat = "csv" | "custom";

export type ExportOptions = {
  format: ExportFormat;
  encrypted?: boolean;
  password?: string;
  compressed?: boolean;
};

export type ImportOptions = {
  overwriteDuplicates?: boolean;
  importValidOnly?: boolean;
  password?: string;
};

export interface ExportResult {
  success: boolean;
  filename: string;
  count: number;
  encrypted: boolean;
  compressed: boolean;
}

export interface ImportResult {
  successCount: number;
  failureCount: number;
  duplicateCount: number;
}

export interface QAddrFileHeader {
  magic: string;
  version: number;
  flags: number;
  dataLength: number;
}

export interface QAddrFileData {
  version: string;
  exportedAt: string;
  addresses: Address[];
}

export interface EncryptedData {
  encrypted: Uint8Array;
  salt: Uint8Array;
  iv: Uint8Array;
  authTag: Uint8Array;
}

export const EXPORT_CONSTANTS = {
  MAGIC_NUMBER: "QADR",
  VERSION: 0x01,
  SALT_LENGTH: 16,
  IV_LENGTH: 12,
  AUTH_TAG_LENGTH: 16,
  PBKDF2_ITERATIONS: 100000,
  KEY_LENGTH: 256,
  FLAGS: {
    ENCRYPTED: 0x01,
    COMPRESSED: 0x02,
  },
} as const;
